export const FEATURE_NAME = 'terminal-tabs';

// Persisted tabs of other services are dropped once older than this,
// or once more than `PERSISTED_TABS_MAX_KEYS` services are stored.
export const PERSISTED_TABS_MAX_AGE_MS = 7 * 24 * 60 * 60 * 1000;
export const PERSISTED_TABS_MAX_KEYS = 10;
